<template>
  <div class="error">
    <h1>Ups! ocurrio un error reintentar más tarde.</h1>
  </div>
</template>
